export default __webpack_public_path__ + "static/media/UnlockedIconWhite.cd5aeb7b.svg";